import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

const AddPricebookBtn = props => (
  <div
    tabIndex={0}
    role="button"
    className="add-pricebook-card"
    data-test="addpricebook-btntnb-pricebook-section"
    onClick={() => props.btnAction(true)}
    onKeyDown={() => {}}>
    <div className="add-pricebook-section">
      <div className="add-icon">
        <FontAwesomeIcon icon={["far", "plus"]} />
      </div>
      <div className="add-text">Create New Price Book</div>
    </div>
  </div>
);

export default AddPricebookBtn;
